import React from 'react';
import { connect } from 'react-redux';
import Header from '../common/Header';
import CanslimSearch from './CanslimSearch';
import Const from './Const';
import CanslimPopup from './CanslimPopup';
import TableCanslim from './Table';
import './index.scss';
import {
  REDUCER_NAME,
  fetchCanSlimData,
  fetchValueInvestment,
  setSortState,
  defaultSortState,
} from './reducer';
import { I18n } from 'react-redux-i18n';
const LAST_TIME_RANGE = 10;
const colowHeaderCanslim = '#09a07e';

class Canslim extends React.Component {
  state = {
    resetScrollIndex: 0,
  };

  componentDidMount() {
    const { fetchCanSlimData, fetchValueInvestment } = this.props;
    fetchCanSlimData();
    fetchValueInvestment();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { resetScrollIndex } = this.state;
    const { sortState, fetchCanSlimData } = this.props;
    const isSortStateChange =
      sortState !== prevProps.sortState &&
      Const.fetchDataSortKeys.includes(Object.keys(sortState)[0]);
    if (isSortStateChange) {
      this.setState({
        resetScrollIndex: resetScrollIndex + 1,
      });
      fetchCanSlimData(true);
    }
  }

  onSort = sortState => {
    const { setSortState } = this.props;
    if (!Object.keys(sortState).length) {
      setSortState(defaultSortState);
      return;
    }
    setSortState(sortState);
  };

  render() {
    const { resetScrollIndex } = this.state;
    const {
      investData: { valueInvestTable = [] },
    } = this.props;
    const lastTimeRange = valueInvestTable.find(
      time => time.timeRange === LAST_TIME_RANGE,
    );

    return (
      <div className="strategy-canslim d-flex flex-fill flex-column">
        <Header
          firstStrName={I18n.t(`canslim.firstStrName`)}
          secondStrName={I18n.t(`canslim.secondStrName`)}
          title={I18n.t(`canslim.title`)}
          isShowCheckbox={false}
          color={colowHeaderCanslim}
          data={lastTimeRange}
        />
        <div className="body-canslim-strategy d-flex flex-fill flex-column px-20">
          <div className="search-canslim">
            <CanslimSearch />
          </div>
          <div className="d-flex flex-fill flex-column mt-10 mb-10">
            <TableCanslim
              resetScrollIndex={resetScrollIndex}
              onSort={this.onSort}
              title={'canslim.tableCanslim'}
              schemaKey={Const.tableCanslim}
            />
            <CanslimPopup />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  canSlimData: state[REDUCER_NAME].canSlimData,
  investData: state[REDUCER_NAME].investData,
  sortState: state[REDUCER_NAME].sortState,
});

const mapDispatchToProps = {
  fetchCanSlimData,
  fetchValueInvestment,
  setSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Canslim);
